import { createFileRoute } from '@tanstack/react-router';
import { ReleaseNoteEditionView } from '@/features/release-notes/ReleaseNoteEditionView';
import { useViewAsId } from '@/lib/viewAs';

function EditionRoute() {
  const { key } = Route.useParams();
  return <ReleaseNoteEditionView editionKey={key} asUser={useViewAsId()} />;
}

export const Route = createFileRoute('/release-notes/$key')({ component: EditionRoute });
